// extracted by mini-css-extract-plugin
export default {"selectDayAndMonth":"styles_selectDayAndMonth__rTm-C"};